import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SafeHtml } from '@angular/platform-browser';
import { DomSanitizer } from '@angular/platform-browser';

export interface Alert {
  id: number;
  type: 'success' | 'danger';
  message: string;
  safeHtml?: SafeHtml; // Add this line
  autoClose: boolean;
}

@Injectable({
  providedIn: 'root'
})

export class AlertService {

  private alertsSubject = new BehaviorSubject<Alert[]>([]);
  alerts$ = this.alertsSubject.asObservable();
  private currentId = 0;

  constructor(private sanitizer: DomSanitizer) { }

  showAlert(type: 'success' | 'danger', message: string, autoClose: boolean = true) {
    const id = this.currentId++;
    
    // Sanitize HTML content
    const safeHtml = this.sanitizer.bypassSecurityTrustHtml(message);
    
    const newAlert: Alert = { 
      id, 
      type, 
      message, 
      safeHtml, // Add the sanitized HTML
      autoClose 
    };
    
    this.alertsSubject.next([...this.alertsSubject.value, newAlert]);
    
    if (autoClose) {
      setTimeout(() => this.removeAlert(id), 3000);
    }
  }

  success(message: string, autoClose: boolean = true) {
    this.showAlert('success', message, autoClose);
  }

  danger(message: string, autoClose: boolean = true) {
    this.showAlert('danger', message, autoClose);
  }

  removeAlert(id: number) {
    this.alertsSubject.next(this.alertsSubject.value.filter(alert => alert.id !== id));
  }

  clearAlerts() {
    this.alertsSubject.next([]);
  }
}
